var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIzinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0003,
    cy: 24.0001,
    r: 23.3333,
    fill: "#EBF0FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8581 16.4902C15.4799 16.5332 15.0243 16.6879 14.6461 16.8942C14.2722 17.1048 13.7135 17.6592 13.4815 18.0546C13.258 18.4414 13.0904 18.9098 13.1505 19.0001C13.1892 19.0516 23.8433 25.5713 23.9851 25.6271C24.0409 25.6486 34.7895 19.0946 34.854 19.0001C34.8841 18.9528 34.8669 18.8496 34.7981 18.6434C34.6391 18.1792 34.3813 17.7881 33.9773 17.3884C33.6721 17.0833 33.5389 16.9844 33.1994 16.8211C32.4 16.43 33.2767 16.4687 24.1957 16.4601C19.7733 16.4558 16.0214 16.4687 15.8581 16.4902Z",
    fill: "#3661EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25.3907C13 30.0494 13 29.9936 13.2149 30.5781C13.5802 31.5536 14.487 32.3444 15.5314 32.5894C15.8408 32.6625 16.3178 32.6667 24.0022 32.6667C31.6865 32.6667 32.1635 32.6625 32.473 32.5894C33.5431 32.3401 34.4542 31.5322 34.8066 30.5093C35.0043 29.9463 35.0086 29.8904 34.9957 25.352L34.9828 21.0457L29.8685 24.1616C27.0535 25.8764 24.664 27.3247 24.5523 27.3849C24.26 27.5353 23.9119 27.5611 23.6154 27.4579C23.4821 27.4106 21.0969 25.9838 18.2217 24.226C15.3852 22.4898 13.0516 21.0672 13.0344 21.0543C13.0129 21.0457 13 22.9969 13 25.3907Z",
    fill: "#3661EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIzinIcon);
export default __webpack_public_path__ + "static/media/izin-icon.6e8754c57b8beedacc7a09d0d9bfc13a.svg";
export { ForwardRef as ReactComponent };